import { Injectable } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import {
	BrandDetailsInfo,
	BrandImportPreviewData,
	BrandInputItem,
	BrandsActions,
	Checkbox
} from '@models/brands.model';
import { FormGroup } from '@angular/forms';

@Injectable()
export class BrandsServiceProvider {
	constructor(private messageService: MessageService) {}

	validateBrandFields(brandControls): void {
		const nameField = brandControls.name.errors;
		const emailField = brandControls.email.errors;

		if (nameField && (nameField.required || nameField.whitespace)) {
			return this.showValidationError('Ahem!', 'Please enter a company name.');
		}

		if (emailField && (emailField.required && emailField.whitespace)) {
			return this.showValidationError(
				'Ahem!',
				'Please enter a company email address.'
			);
		}

		if (emailField && emailField.invalidEmail) {
			this.messageService.showToaster('e_1', 'general');
		}
	}

	showValidationError(title: string, text: string): void {
		this.messageService.showErrorFromBackend(title, text);
	}

	createActionList(actions: BrandsActions): Array<string> {
		return Object.keys(actions);
	}

	createFormGroup(
		inputs: Array<BrandInputItem>,
		data: BrandDetailsInfo
	): FormGroup {
		const fbData = <FormGroup>{};
		inputs.forEach((e: BrandInputItem): void => {
			fbData[e.formControlName] = [data[e.formControlName], e.validators];
		});
		return fbData;
	}

	createImportListToSave(
		formGroup,
		checkBoxes: Array<Checkbox>
	): Array<string> | null {
		const importList = <Array<string>>[];

		Object.keys(formGroup.controls).forEach(
			(control: string, groupIndex: number): void => {
				formGroup.controls[control].controls.forEach(
					(control, checkboxIndex: number) => {
						if (control.value) {
							importList.push(
								checkBoxes[groupIndex].children[checkboxIndex].controlName
							);
						}
					}
				);
			}
		);

		return importList;
	}

	mapImportActions(importData: BrandImportPreviewData): Array<Checkbox> {
		const importActions = Object.keys(importData.availableDataToImport);
		const categories = this.createCheckboxGroups(importData, importActions);

		importActions.forEach((e: string) => {
			if (importData.availableDataToImport[e].group === categories[0].title) {
				categories[0].children.push({
					title: importData.availableDataToImport[e].label,
					isChecked: true,
					controlName: e,
					children: []
				});
			}
		});

		return categories;
	}

	private createCheckboxGroups(
		importData: BrandImportPreviewData,
		importActions: Array<string>
	): Array<Checkbox> {
		const categories: Array<Checkbox> = [];
		const groups = new Set();

		importActions.forEach((e: string) => {
			groups.add(importData.availableDataToImport[e].group);
		});

		groups.forEach((groupName: string): void => {
			categories.push({
				title: groupName,
				isChecked: true,
				controlName: groupName,
				children: []
			});
		});

		return categories;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=cbiehorjf0u!./shared/services/brands/brands.service.ts